package one.healthium.paywall.ui.components

import androidx.compose.foundation.background
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import one.healthium.domain.paywall.models.PaywallReviewsView
import one.healthium.ui.common.utils.toColor
import one.healthium.ui.components.ReviewsPager

@Composable
fun PaywallReviewsView(model: PaywallReviewsView) {
    val config = model.config
    if (config.items.isEmpty()) return

    ReviewsPager(
        modifier = Modifier.background(config.bgColor?.toColor() ?: Color.Transparent),
        reviews = config.items,
        authorTextStyle = config.authorTextStyle,
        reviewTextStyle = config.reviewTextStyle,
    )
}